export default __webpack_public_path__ + "static/media/1.aa76a77b.jpg";